module.exports = __webpack_public_path__ + "img/vacations.6d7151de.svg";